// extracted by mini-css-extract-plugin
export default {"switch":"Switch_switch__n+oYF","switch-input":"Switch_switch-input__6ytuZ","slider":"Switch_slider__CmgZ0","cursor":"Switch_cursor__6fpFX"};